export { PmdTransclude } from './ng-transclude.directive';
export { PmdTab } from './tab.directive';
export { PmdTabLabel } from './tab-heading.directive';
export { PmdTabGroup } from './tab-group.component';
export { PmdTabGroupConfig } from './tabset.config';
export { PmdTabsModule } from './tabs.module';